import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBIcon,
  MDBPopconfirm, MDBPopconfirmMessage,
} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';

import moment from 'moment';
import Alert from './sub/dialog'



import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';


const Component = () => {
  const alert = useRef();
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [filterDriver, setFilterDriver] = useState('all');
  const setError = (message, ismessage) => (ismessage ? alert.current.showmessage(message) : alert.current.showerror(message));

  const getcustomer = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getCustomers`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setCustomers(data.Customers);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch user');
      }
    } catch (err) {
      setError('An error occurred while fetching user.');
    }
  }

  const deleteRow = async (customer) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deleteCustomer`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ customer }),

      });
      const data = await response.json();
      if (response.ok) {
        var item = customers.filter(el => el !== customer);

        setCustomers([...item]);
        alert.current.showmessage(data.message);
      } else {

        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }


  }

  useEffect(() => {
    // Get the token from sessionStorage


    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    getcustomer();

  }, []);

  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={alert} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='10'>
                  <h4>จัดการข้อมูลลูกค้า</h4>
                </MDBCol>

              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>
              <MDBRow className='mb-3'>
                <MDBCol md='6'>
                <MDBBtn    onClick={() => window.open('/ManageCustomerProfile/', '_blank')}>
                        <MDBIcon icon='plus' className='me-1' />เพิ่มลูกค้าใหม่
                      </MDBBtn>
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-3'>
                <MDBCol md='6'>
                  <FormControl component="fieldset">
                    
                    <RadioGroup row value={filterDriver} onChange={(e) => setFilterDriver(e.target.value)}>
                      <FormControlLabel value="all" control={<Radio />} label="ทั้งหมด" />
                      <FormControlLabel value="driver" control={<Radio />} label="คนรถ" />
                      <FormControlLabel value="nondriver" control={<Radio />} label="ลูกค้า" />
                    </RadioGroup>
                  </FormControl>
                </MDBCol>
              </MDBRow>
              <MDBRow className='mb-3'>
              <MDBCol md='8'>
              <MDBTable align='middle'>
                <MDBTableHead>
                  <tr>
                    <th scope='col'>รหัสลูกค้า</th>
                    <th scope='col'>ชื่อ</th>
                    <th scope='col'>ชื่อเรียก</th>
                    <th scope='col' className='text-center'>คนรถ</th>
                    <th scope='col' className='text-center col-md-2'>แก้ไข</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {customers
                    .filter(row => {
                      if (filterDriver === 'driver') return row.isdriver === 1;
                      if (filterDriver === 'nondriver') return row.isdriver !== 1;
                      return true;
                    })
                    .map((row, i) => (<tr key={i}>
                    <td>{row.customer_id}</td>
                    <td>{row.text}</td>
                    <td>{row.name_alt}</td>
                    <td className='text-center'>{row.isdriver === 1 ? <MDBIcon icon='check-circle' size='lg' color='success' /> : ''}</td>
                    <td className='text-center'>
                      <MDBBtn outline size='sm' floating className='call-btn' onClick={() => window.open('/ManageCustomerProfile/' + row.customer_id, '_blank')}>
                        <MDBIcon icon='pen' />
                      </MDBBtn>
                     <MDBPopconfirm

                  onConfirm={() => deleteRow(row)}
                  placement='bottom'
                  btnChildren={<MDBIcon icon='trash' />}
                  btnClassName='ms-2 btn-sm btn-danger btn-floating'
                  cancelBtnText='ยกเลิก'
                  confirmBtnText='ตกลง'
                  confirmBtnClasses='btn-danger'
                  cancelBtnClasses='btn btn-outline-primary'
                >
                  <MDBPopconfirmMessage>ยืนยันที่จะลบ?</MDBPopconfirmMessage>
                </MDBPopconfirm>
                    </td>
                  </tr>))}

                </MDBTableBody>
              </MDBTable>
              </MDBCol>
              </MDBRow>
            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>



    </MDBContainer>
  </>);
};

export default Component;
